export default {
  styleOverrides: {
    contained: {
      borderRadius: 8
    }
  }
};
